import { Link, useSearchParams } from 'react-router-dom';
import { useIdentityStatus, useStartIdentity } from '../hooks/useIdentity.js';
import { SpinnerButton } from '../components/SpinnerButton.js';

export function AccountVerifyPage() {
  const { data, isLoading } = useIdentityStatus();
  const start = useStartIdentity();
  const [params] = useSearchParams();
  const justReturned = params.get('return') === '1';

  if (isLoading) {
    return <div className="mx-auto max-w-2xl px-4 py-16 text-navy-500">Loading…</div>;
  }

  const verified = data?.verified ?? false;

  return (
    <div className="mx-auto max-w-2xl px-4 py-16">
      <Link to="/account" className="text-sm text-navy-500 hover:text-navy">
        ← Back to account
      </Link>
      <h1 className="text-3xl font-bold text-navy mt-4 mb-2">Verify your ID</h1>
      <p className="text-navy-600 mb-8">
        We require a one-time photo ID check before your first booking on TowShare. Powered
        by Stripe Identity. Takes about 60 seconds.
      </p>

      {justReturned && !verified && (
        <div className="mb-6 rounded-lg bg-orange-50 border border-orange-200 p-4 text-sm text-navy-700">
          We're still processing your verification. This usually clears within a minute.
        </div>
      )}

      <div className="card p-6">
        {verified ? (
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-green-100 text-green-700 text-xl">
              ✓
            </span>
            <div>
              <p className="font-semibold text-navy">You're verified</p>
              <p className="text-sm text-navy-500">
                Verified on{' '}
                {data?.verifiedAt
                  ? new Date(data.verifiedAt).toLocaleDateString()
                  : 'recently'}
              </p>
            </div>
          </div>
        ) : (
          <>
            <h2 className="text-lg font-semibold text-navy mb-2">What you'll need</h2>
            <ul className="text-sm text-navy-700 space-y-1 mb-6 list-disc pl-5">
              <li>A government-issued photo ID (driver's license, passport, or provincial ID)</li>
              <li>Your phone or laptop camera for a selfie match</li>
              <li>About a minute</li>
            </ul>
            <SpinnerButton
              className="btn-primary w-full"
              loading={start.isPending}
              onClick={() => start.mutate()}
            >
              {start.isPending ? 'Opening Stripe Identity…' : 'Start verification'}
            </SpinnerButton>
            {start.isError && (
              <p className="text-sm text-red-600 mt-3">
                Couldn't start verification. Make sure Stripe is configured and try again.
              </p>
            )}
            <p className="text-xs text-navy-400 text-center mt-4">
              Your documents are processed by Stripe Identity, never stored by TowShare.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
